module.exports = __webpack_public_path__ + "img/46.49ab274e.jpg";